import { colors } from 'utils/colors'
import useLiveCall from 'hooks/use-live-call'

import Pulse from '../Pulse'
import { Container } from '../shared/style'
import { useAppSelector } from 'store'
import { useDialerUIContext } from 'modules/DialerClient/DialerUIContext'
import { useCallback, useEffect, useRef, useState } from 'react'
import { IconButton } from 'components'

const LiveCallStatus = () => {
  const userState = useAppSelector((state) => state.user)
  const { state } = useDialerUIContext()
  const { goToActivity } = useLiveCall()

  const defaultResetCount = 15
  const [resetTimerCounter, setResetTimerCounter] = useState<number>(defaultResetCount)
  const [isFetchingReset, setIsFetchingReset] = useState<boolean>(false)
  const prevCallStatus = useRef<string | null>(null)

  const {
    liveCall: {},
  } = useAppSelector((state) => state)

  const dialerUrl = userState.user?.dialerUrl || ''
  const sip = userState.user?.sip || ''
  const userId = userState.user?.id || ''
  const isShow = state.appBarCallStatus != null
  const callStatus = state.appBarCallStatus?.message || ''
  const resettable = state.appBarCallStatus?.resettable ?? false

  useEffect(() => {
    if (callStatus !== prevCallStatus.current) {
      prevCallStatus.current = callStatus
      setResetTimerCounter(defaultResetCount)
      setIsFetchingReset(false)
    }
  }, [resettable, callStatus])

  const resetStateCallback = useCallback(async () => {
    setIsFetchingReset(true)
    try {
      const queryParams = new URLSearchParams({
        sip: sip,
        meta: JSON.stringify({ reset_by: userId }),
      })
      await fetch(`${dialerUrl}/reset-session?${queryParams.toString()}`)
    } finally {
      setIsFetchingReset(false)
    }
  }, [dialerUrl, sip, userId])

  useEffect(() => {
    if (!resettable || resetTimerCounter <= 0) return

    const intervalId = setInterval(() => {
      setResetTimerCounter((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [resettable, resetTimerCounter])

  return (
    <>
      {isShow && (
        <>
          <Container
            onClick={() => goToActivity()}
            backgroundColor={resettable && resetTimerCounter <= 0 ? colors.yellow : colors.red2}
          >
            <Pulse />
            {callStatus}
            {resettable && resetTimerCounter > 0 && `${resetTimerCounter}`}
          </Container>
          {resettable && resetTimerCounter <= 0 && (
            <div style={{ marginLeft: '-25px' }}>
              <IconButton
                disabled={isFetchingReset}
                size={'small'}
                icon={['far', 'arrow-rotate-right']}
                variant={'criticalOutline'}
                onClick={resetStateCallback}
              />
            </div>
          )}
        </>
      )}
    </>
  )
}

export default LiveCallStatus
